"use client";
import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Close as p } from "@videoblocks/react-icons";
import { Dialog as f, DialogContent as g, DialogHeader as u, DialogTitle as C, DialogClose as r, DialogFooter as x } from "../../atoms/Dialog/Dialog.mjs";
import { Text as N } from "../../atoms/Text/Text.mjs";
import { Button as i } from "../../atoms/Button/Button.mjs";
import { cn as y } from "../../../utils/utils.mjs";
const z = ({
  isOpen: a,
  title: t,
  content: l,
  onCancel: n,
  onConfirm: s,
  confirmLabel: c = "Confirm",
  cancelLabel: m = "Cancel",
  className: d
}) => /* @__PURE__ */ e(f, { open: a, onOpenChange: (h) => !h && n(), children: /* @__PURE__ */ o(g, { className: y("gap-10 p-8 rounded-sm border-0", d), showCloseButton: !1, children: [
  /* @__PURE__ */ o(u, { className: "flex-row items-center justify-between", children: [
    /* @__PURE__ */ e(C, { fontSize: "2xl", className: "text-gray-900", children: t }),
    /* @__PURE__ */ e(
      r,
      {
        className: "opacity-70 hover:opacity-100 transition-opacity cursor-pointer",
        "aria-label": "close",
        children: /* @__PURE__ */ e(p, { className: "w-4 h-4 fill-current" })
      }
    )
  ] }),
  /* @__PURE__ */ e(N, { fontSize: "base", fontWeight: "regular", className: "text-gray-900", children: l }),
  /* @__PURE__ */ o(x, { className: "gap-4", children: [
    /* @__PURE__ */ e(r, { asChild: !0, children: /* @__PURE__ */ e(i, { variant: "outlined-dark", children: m }) }),
    /* @__PURE__ */ e(i, { onClick: s, children: c })
  ] })
] }) });
export {
  z as ConfirmationModal
};
